/**
 * Format a string value to Brazilian currency (R$)
 * @param value - String value with only digits
 * @returns Formatted currency string
 */
export const formatCurrency = (value: string): string => {
  const digits = value.replace(/\D/g, '');
  const number = Number(digits) / 100;

  return number.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  });
};

/**
 * Parse a formatted currency string to a number
 * @param value - Formatted currency string (e.g., "R$ 1.234,56")
 * @returns Numeric value
 */
export const parseCurrency = (value: string): number => {
  const digits = value.replace(/\D/g, '');
  return Number(digits) / 100;
};

export const maskCpf = (value: string): string => {
  const digits = value.replace(/\D/g, '');
  return digits
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
};

export const maskCnpj = (value: string): string => {
  const digits = value.replace(/\D/g, '');
  return digits
    .replace(/^(\d{2})(\d)/, '$1.$2')
    .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
    .replace(/\.(\d{3})(\d)/, '.$1/$2')
    .replace(/(\d{4})(\d)/, '$1-$2');
};

export const maskCpfCnpj = (value: string): string => {
  const digits = value.replace(/\D/g, '');

  if (digits.length <= 11) {
    return maskCpf(digits);
  }

  return maskCnpj(digits);
};
